module.exports = {
  id: 7,
  name: 'High Knees',
  categories: ['cardio', 'legs', 'coordination'],
  sports: [
    'basketball',
    'boxing',
    'dance',
    'football',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Cardio',
  points: 10,
  instructions:
    "High knees time! The ground is LAVA! Lift your knees up high toward your chest, then hop! Keep alternating knees and hopping! Don't let your feet touch the hot lava!",
  timedInstructions: [
    {
      time: 0,
      text: 'Ready to lift those knees high? The ground is LAVA!',
    },
    {
      time: 2,
      text: 'Stand with feet apart, the lava is bubbling!',
    },
    {
      time: 4,
      text: 'The Floor is Lava! Hop, hop hop, knees up, up up!',
    },
    {
      time: 6,
      text: "3, 2, 1, DON'T TOUCH THE LAVA!",
    },
    // SET 1 - 10 reps
    {
      time: 7,
      text: 'Lift right knee and hop! The lava is hot!',
    },
    {
      time: 9,
      text: 'Lift left knee and hop! Keep those feet up!',
    },
    {
      time: 11,
      text: 'Lift right knee and hop! The ground is burning!',
    },
    {
      time: 13,
      text: "Lift left knee and hop! Don't touch the lava!",
    },
    {
      time: 15,
      text: "Keep going, you're doing great! The lava is bubbling!",
    },
    {
      time: 17,
      text: 'Lift higher and hop! The ground is super hot!',
    },
    {
      time: 19,
      text: "Lift right knee and hop! You're a lava jumper!",
    },
    {
      time: 21,
      text: 'Lift left knee and hop! Keep those feet high!',
    },
    {
      time: 23,
      text: 'Lift right knee and hop! The lava is sizzling!',
    },
    {
      time: 25,
      text: "Lift left knee and hop! Don't get burned!",
    },
    {
      time: 27,
      text: 'Keep going, almost there! The lava is everywhere!',
    },
    {
      time: 29,
      text: "Lift higher and hop! You're a lava master!",
    },
    {
      time: 31,
      text: 'Lift right knee and hop! The ground is scorching!',
    },
    {
      time: 33,
      text: 'Lift left knee and hop! Keep jumping high!',
    },
    {
      time: 35,
      text: "Lift right knee and hop! You're avoiding the lava!",
    },
    {
      time: 37,
      text: 'Lift left knee and hop! Lava warrior!',
    },
    // REST PERIOD 1 - 15 seconds
    {
      time: 39,
      text: 'Amazing job! Take a good break now, the lava cooled down!',
    },
    {
      time: 42,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 45,
      text: "You just did 10 high knees, that's incredible!",
    },
    {
      time: 48,
      text: 'Your legs are getting so strong!',
    },
    {
      time: 51,
      text: 'Remember to lift your knees up high',
    },
    {
      time: 54,
      text: 'Keep alternating left and right',
    },
    {
      time: 57,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 60,
      text: "You're building amazing cardio power!",
    },
    {
      time: 63,
      text: 'Ready for round two, lava warrior!',
    },
    {
      time: 66,
      text: '3, 2, 1, THE LAVA IS BACK!',
    },
    // SET 2 - 10 reps
    {
      time: 69,
      text: 'Lift right knee and hop! The lava is bubbling again!',
    },
    {
      time: 71,
      text: 'Lift left knee and hop! Keep those feet up high!',
    },
    {
      time: 73,
      text: 'Lift right knee and hop! The ground is super hot!',
    },
    {
      time: 75,
      text: "Lift left knee and hop! Don't touch the lava!",
    },
    {
      time: 77,
      text: "Keep going, you're doing great! The lava is everywhere!",
    },
    {
      time: 79,
      text: "Lift higher and hop! You're a lava jumper!",
    },
    {
      time: 81,
      text: 'Lift right knee and hop! The ground is scorching!',
    },
    {
      time: 83,
      text: 'Lift left knee and hop! Keep jumping high!',
    },
    {
      time: 85,
      text: 'Lift right knee and hop! The lava is sizzling!',
    },
    {
      time: 87,
      text: "Lift left knee and hop! Don't get burned!",
    },
    {
      time: 89,
      text: 'Keep going, almost there! The lava is hot hot!',
    },
    {
      time: 91,
      text: "Lift higher and hop! You're a lava master!",
    },
    {
      time: 93,
      text: 'Lift right knee and hop! The ground is burning!',
    },
    {
      time: 95,
      text: 'Lift left knee and hop! Keep those feet up!',
    },
    {
      time: 97,
      text: "Lift right knee and hop! You're avoiding the lava!",
    },
    {
      time: 99,
      text: 'Lift left knee and hop! Lava champion!',
    },
    // REST PERIOD 2 - 15 seconds
    {
      time: 101,
      text: 'Incredible work! Take another break, the lava cooled again!',
    },
    {
      time: 104,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 107,
      text: 'You just did 20 high knees total!',
    },
    {
      time: 110,
      text: 'Your legs are getting stronger!',
    },
    {
      time: 113,
      text: 'Remember to lift your knees up high',
    },
    {
      time: 116,
      text: 'Keep alternating left and right',
    },
    {
      time: 119,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 122,
      text: "You're becoming a cardio master!",
    },
    {
      time: 125,
      text: 'Ready for round three, lava champion!',
    },
    {
      time: 128,
      text: '3, 2, 1, THE LAVA IS BACK AGAIN!',
    },
    // SET 3 - 10 reps
    {
      time: 131,
      text: 'Lift right knee and hop! The lava is super hot!',
    },
    {
      time: 133,
      text: 'Lift left knee and hop! Keep those feet up high!',
    },
    {
      time: 135,
      text: 'Lift right knee and hop! The ground is scorching!',
    },
    {
      time: 137,
      text: "Lift left knee and hop! Don't touch the lava!",
    },
    {
      time: 139,
      text: "Keep going, you're doing great! The lava is everywhere!",
    },
    {
      time: 141,
      text: "Lift higher and hop! You're a lava jumper!",
    },
    {
      time: 143,
      text: 'Lift right knee and hop! The ground is burning!',
    },
    {
      time: 145,
      text: 'Lift left knee and hop! Keep jumping high!',
    },
    {
      time: 147,
      text: 'Lift right knee and hop! The lava is sizzling!',
    },
    {
      time: 149,
      text: "Lift left knee and hop! Don't get burned!",
    },
    {
      time: 151,
      text: 'Keep going, almost there! The lava is hot hot!',
    },
    {
      time: 153,
      text: "Lift higher and hop! You're a lava master!",
    },
    {
      time: 155,
      text: 'Lift right knee and hop! The ground is super hot!',
    },
    {
      time: 157,
      text: 'Lift left knee and hop! Keep those feet up!',
    },
    {
      time: 159,
      text: "Lift right knee and hop! You're avoiding the lava!",
    },
    {
      time: 161,
      text: 'Lift left knee and hop! Lava superstar!',
    },
    // REST PERIOD 3 - 15 seconds
    {
      time: 163,
      text: 'Fantastic work! Take a final break, the lava cooled down!',
    },
    {
      time: 166,
      text: 'Breathe in and out, feel your power',
    },
    {
      time: 169,
      text: 'You just did 30 high knees total!',
    },
    {
      time: 172,
      text: 'Your legs are incredibly strong!',
    },
    {
      time: 175,
      text: 'Remember to lift your knees up high',
    },
    {
      time: 178,
      text: 'Keep alternating left and right',
    },
    {
      time: 181,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 184,
      text: "You're a cardio superstar!",
    },
    {
      time: 187,
      text: 'Ready for the final round, lava master!',
    },
    {
      time: 190,
      text: '3, 2, 1, FINAL LAVA BATTLE!',
    },
    // SET 4 - 10 reps
    {
      time: 193,
      text: 'Lift right knee and hop! The lava is super hot!',
    },
    {
      time: 195,
      text: 'Lift left knee and hop! Keep those feet up high!',
    },
    {
      time: 197,
      text: 'Lift right knee and hop! The ground is scorching!',
    },
    {
      time: 199,
      text: "Lift left knee and hop! Don't touch the lava!",
    },
    {
      time: 201,
      text: "Keep going, you're doing great! The lava is everywhere!",
    },
    {
      time: 203,
      text: "Lift higher and hop! You're a lava jumper!",
    },
    {
      time: 205,
      text: 'Lift right knee and hop! The ground is burning!',
    },
    {
      time: 207,
      text: 'Lift left knee and hop! Keep jumping high!',
    },
    {
      time: 209,
      text: 'Lift right knee and hop! The lava is sizzling!',
    },
    {
      time: 211,
      text: "Lift left knee and hop! Don't get burned!",
    },
    {
      time: 213,
      text: 'Keep going, almost there! The lava is hot hot!',
    },
    {
      time: 215,
      text: "Lift higher and hop! You're a lava master!",
    },
    {
      time: 217,
      text: 'Lift right knee and hop! The ground is super hot!',
    },
    {
      time: 219,
      text: 'Lift left knee and hop! Keep those feet up!',
    },
    {
      time: 221,
      text: "Lift right knee and hop! You're avoiding the lava!",
    },
    {
      time: 223,
      text: 'Lift left knee and hop! Lava champion!',
    },
    {
      time: 225,
      text: 'You did it, lava master!',
    },
    {
      time: 227,
      text: 'Incredible work! You did 40 high knees!',
    },
    {
      time: 229,
      text: 'Your legs are incredibly strong!',
    },
    {
      time: 231,
      text: 'You are a lava jumping champion!',
    },
  ],
};
